import { reportAction } from '#pplx/frontend/metrics/browser.js';
export const reportAutosuggestLatencies = ({ latencies, isMobile, }) => {
    reportAction('web.frontend.autosuggest_latency', {
        latencies,
        isMobile,
    });
};
//# sourceMappingURL=reportAutosuggestLatencies.js.map